
import { v4 as uuidv4 } from "uuid";
import { 
  FloatingFeature,
  FeatureUserRating
} from "@models";
import { AttackType, FeatureType } from "@dndModels/Types";

// import DataUtilities from "../utilities/common_utilities";
// import { DataUtilitiesClass } from "../utilities/common_utilities_class";


/**
 * This represents a specific thing that a character can have.
 * It connects to the character through their 
 * class, subclass, race, or background, 
 * via FeatureBase.
 */
export class Feature {
  parent_type = "";
  parent_id = "";
  base_id = "";
  
  true_id = "";
  floating_feature_id = "";
  old_obj: any = null;
  floating_feature: FloatingFeature | null = null;
  
  constructor(obj?: any, is_new = false) {
    // this.common_util = DataUtilities.getInstance();
    this.true_id = obj && obj.true_id && !is_new ? obj.true_id : uuidv4().toString();
    if (obj) {
      this.floating_feature_id = obj.floating_feature_id ? obj.floating_feature_id : "";
      this._feature_type = obj.feature_type ? obj.feature_type : "";
      if (obj instanceof Feature) {
        this.floating_feature = obj.floating_feature;
        this.old_obj = obj.old_obj;
      } else if (obj.old_obj) {
        this.old_obj = obj.old_obj;
      } else {
        this.old_obj = obj;
      }
      // if (this.old_obj.old_obj) {
      //   delete this.old_obj.old_obj;
      // }
    }
  }

  // common_util: DataUtilitiesClass;

  // get floating_feature(): FloatingFeature | null {
  //   return this.common_util.get_floating_feature(this.floating_feature_id);
  // }

  get the_effect_types() {
    return this.floating_feature ? this.floating_feature.the_effect_types : [];
  }

  get damage_types() {
    return this.floating_feature ? this.floating_feature.damage_types : [];
  }

  get associatedDamageTypes() {
    return this.floating_feature ? this.floating_feature.associatedDamageTypes : [];
  }

  get the_utility_details(): string[] {
    return this.floating_feature ? this.floating_feature.the_utility_details : [];
  }

  // get_the_effect_types(): string[] {
  //   // debugger;
  //   return this.floating_feature ? this.floating_feature.the_effect_types : [];
  // }

  get the_attack_types(): AttackType[] {
    return this.floating_feature ? this.floating_feature.the_attack_types : [];
  }

  get avg_feature_points(): number {
    if (this.floating_feature) {
      return this.floating_feature.avg_feature_points;
    }
    return 0;
  }

  get feature_points(): number {
    if (this.floating_feature) {
      return this.floating_feature.feature_points;
    }
    return 0;
  }

  get feature_points_from_admin(): number {
    if (this.floating_feature) {
      return this.floating_feature.feature_points_from_admin;
    }
    return 0;
  }
  
  get feature_points_from_users(): FeatureUserRating[] {
    if (this.floating_feature) {
      return this.floating_feature.feature_points_from_users;
    }
    return [];
  }

  get name(): string {
    if (this.floating_feature) {
      return this.floating_feature.name;
    }
    return "";
  }

  get description(): string {
    if (this.floating_feature) {
      return this.floating_feature.description;
    }
    return "";
  }

  _feature_type: FeatureType = "";
  get feature_type() {
    if (this.floating_feature) {
      return this.floating_feature.feature_type;
    }
    return this._feature_type;
  }

  toDBObj(): any {
    return {
      true_id: this.true_id,
      floating_feature_id: this.floating_feature_id,
      feature_type: this.floating_feature?.feature_type??"",
      old_obj: this.old_obj
    };
  }

  copy(copyMe: Feature, drop_ids = false): void {
    if (!drop_ids) {
      this.true_id = copyMe.true_id;
    }
    this.floating_feature_id = copyMe.floating_feature_id;
    this.floating_feature = copyMe.floating_feature;
  }

  clone(drop_ids = false): Feature {
    const new_obj = new Feature();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
  
  connectUserRatings(userRatings: FeatureUserRating[]) {
    const floating_feature = this.floating_feature;
    if (floating_feature) {
      userRatings.filter(o => o.feature_id === this.true_id).forEach(user_rating => {
        floating_feature.feature_points_from_users.push(user_rating);
      });
    }
  }
}